import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {StepDatiGenFascicoloComponent} from './step-dati-gen-fascicolo.component';
import {FascicoloFormSharedModule as FascicoloFormSharedLavoroModule} from '../../../../../lavoro/fascicoloFormShared/fascicolo-form-shared.module';
import {FascicoloFormSharedModule as FascicoloFormSharedCivileModule} from '../../../../../civile/fascicoloFormShared/fascicolo-form-shared.module';
import {FascicoloFormSharedModule as FascicoloFormSharedAutoritaIndModule} from '../../../../../autorita-indipendente/fascicoloFormShared/fascicolo-form-shared.module';
import {FascicoloFormSharedModule as FascicoloFormSharedAmministrativaModule} from '../../../../../amministrativa/fascicoloFormShared/fascicolo-form-shared.module';
import {FascicoloFormSharedModule as FascicoloFormSharedPenaleModule} from '../../../../../penale/fascicoloFormShared/fascicolo-form-shared.module';
import {FascicoloFormSharedModule as FascicoloFormSharedPareristicaModule} from '../../../../../pareristica/fascicoloFormShared/fascicolo-form-shared.module';
import {FascicoloFormSharedModule as FascicoloFormSharedTributatioModule} from '../../../../../tributario/fascicoloFormShared/fascicolo-form-shared.module';
import {TipiFascicoloWidgetComponent} from './components/tipi-fascicolo-widget/tipi-fascicolo-widget.component';
import {CommonTLFModule} from '../../../../../common/common.module';

@NgModule({
  declarations: [
    StepDatiGenFascicoloComponent,
    TipiFascicoloWidgetComponent
  ],
  imports: [
    CommonModule,
    FascicoloFormSharedLavoroModule,
    FascicoloFormSharedCivileModule,
    FascicoloFormSharedAmministrativaModule,
    FascicoloFormSharedAutoritaIndModule,
    FascicoloFormSharedPenaleModule,
    FascicoloFormSharedPareristicaModule,
    FascicoloFormSharedTributatioModule,
    CommonTLFModule
  ],
  exports: [
    StepDatiGenFascicoloComponent
  ]
})
export class StepDatiGenFascicoloModule { }
